// SWR 0.x pasaba cada elemento de una clave tipo arreglo como un argumento
// distinto del fetcher: useSWR([page, perPage, param], fetcher) llamaba a
// fetcher(page, perPage, param). Desde SWR 1 el fetcher recibe la clave entera
// como un solo argumento. Todos los fetchers de la app siguen la firma vieja,
// así que los hooks compartidos los envuelven con esta función en lugar de
// cambiar cada fetcher.
const spreadKeyFetcher = (fetcher) =>
  fetcher && ((key) => (Array.isArray(key) ? fetcher(...key) : fetcher(key)));

export default spreadKeyFetcher;
